import React, { useState } from "react";
import axios from "axios";
import "./donate.css";
import visaIcon from "../../assets/audio/images/visa.png";
import masterIcon from "../../assets/audio/images/logo.png";
import jazzCashIcon from "../../assets/audio/images/jazzcash.jpeg";

export default function DonationForm({
  compact = false,
  hideTitle = false,
  showPayments = true,
}) {
  const API_URL = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    amount: "",
    orderType: "Donation",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/paypro/order`, {
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        amount: formData.amount,
        orderType: formData.orderType,
      });
      const data = response.data;
      if (data?.click2Pay) {
        window.location.href = data.click2Pay;
      } else {
        alert("Order created but no payment URL returned.");
      }
    } catch (error) {
      console.error("Error creating order:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="donate-form-card"
      style={{
        padding: compact ? "24px" : undefined,
      }}
    >
      {!hideTitle && (
        <>
          <h1 className="donate-form-title">Make Online Donation Now</h1>
          <p className="donate-form-subtitle">
            Support our cause with a secure online payment
          </p>
        </>
      )}

      {showPayments && (
        <div
          className={`donate-payments ${hideTitle ? "donate-payments--compact" : ""}`}
          aria-label="Accepted payment methods"
        >
          {!hideTitle && <span className="donate-payments-label">We accept</span>}
          <div className="donate-payments-badges">
            <span className="donate-icon-pill" aria-label="Visa">
              <img className="donate-payments-icon" src={visaIcon} alt="Visa" />
            </span>
            <span className="donate-icon-pill" aria-label="Mastercard">
              <img className="donate-payments-icon" src={masterIcon} alt="Mastercard" />
            </span>
            <span className="donate-icon-pill" aria-label="JazzCash">
              <img
                className="donate-payments-icon donate-payments-icon-jazzcash"
                src={jazzCashIcon}
                alt="JazzCash"
              />
            </span>
            <span className="donate-icon-pill" aria-label="1LINK">
              <img
                className="donate-payments-icon"
                src={`${process.env.PUBLIC_URL}/1link.svg`}
                alt="1LINK"
              />
            </span>
          </div>
        </div>
      )}
      <form className="donate-form" onSubmit={handleSubmit}>
        <div className="donate-form-row">
          <div className="donate-field">
            <label htmlFor="donate-name">Your Name</label>
            <input
              id="donate-name"
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="donate-field">
            <label htmlFor="donate-email">Email</label>
            <input
              id="donate-email"
              type="email"
              name="email"
              placeholder="your@email.com"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="donate-form-row">
          <div className="donate-field">
            <label htmlFor="donate-mobile">Mobile</label>
            <input
              id="donate-mobile"
              type="text"
              name="mobile"
              placeholder="Phone number"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>
          <div className="donate-field">
            <label htmlFor="donate-amount">Amount (PKR)</label>
            <div className="donate-amount-wrap">
              <span className="donate-amount-prefix">PKR</span>
              <input
                id="donate-amount"
                type="number"
                name="amount"
                placeholder="Min 150"
                value={formData.amount}
                onChange={handleChange}
                required
                min="150"
              />
            </div>
          </div>
        </div>
        <div className="donate-field">
          <label htmlFor="donate-type">Donation Type</label>
          <select
            id="donate-type"
            name="orderType"
            value={formData.orderType}
            onChange={handleChange}
            required
          >
            <option value="Donation">Donation</option>
            <option value="Zakat">Zakat</option>
            <option value="Sadqa">Sadqa</option>
          </select>
        </div>
        <button
          type="submit"
          className="donate-submit"
          disabled={loading}
        >
          {loading ? "Processing…" : "Donate Now"}
        </button>
      </form>
    </div>
  );
}
